import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import {
    SimpleGrid,
    Text,
    Button,
    Container,
    Title,
    Alert,
    Box,
    AspectRatio,
    Image,
    Overlay,
} from "@mantine/core";
import { IconAlertCircle, IconPlayerPlayFilled } from "@tabler/icons-react";
import API_BASE_URL from "../config";

const LOCAL_POSTERS = {
    "Interstellar": "/images/poster_interstellar.png",
    "Wicked": "/images/poster_wicked.png",
};

function getLocalPoster(movie) {
    return LOCAL_POSTERS[movie.title] || movie.posterUrl || "/images/poster_action.jpg";
}

function Movies() {
    const [movies, setMovies] = useState([]);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchMovies = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/api/movies`);
                setMovies(response.data);
            } catch (err) {
                setError("Failed to fetch movies: " + (err.response?.data?.message || "Unknown error"));
            }
        };
        fetchMovies();
    }, []);

    return (
        <Container size="xl" py="xl">
            <Title order={1} mb={40} style={{ color: 'white', fontWeight: 700, letterSpacing: '-1px' }}>
                Now Showing
            </Title>

            {error && (
                <Alert icon={<IconAlertCircle size={16} />} title="Error" color="red" mb="xl">
                    {error}
                </Alert>
            )}

            <SimpleGrid cols={{ base: 1, sm: 2, md: 3, lg: 4 }} spacing={30}>
                {movies.map((movie) => (
                    <Box
                        key={movie.id}
                        component={Link}
                        to={`/movies/${movie.id}/seats`}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                        <AspectRatio ratio={2 / 3} style={{ borderRadius: 12, overflow: 'hidden', position: 'relative', transition: 'transform 0.3s ease' }}
                            sx={{
                                '&:hover': {
                                    transform: 'scale(1.03)',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
                                    zIndex: 1
                                }
                            }}
                        >
                            <Image
                                src={getLocalPoster(movie)}
                                alt={movie.title}
                                fallbackSrc="/images/poster_action.jpg"
                                style={{ objectFit: 'cover', height: '100%', width: '100%' }}
                            />
                            <Overlay
                                gradient="linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 90%)"
                                opacity={0.8}
                                zIndex={2}
                            />

                            <Box
                                style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    padding: 20,
                                    zIndex: 3,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'flex-end',
                                    height: '100%'
                                }}
                            >
                                <Box>
                                    <Text weight={700} size="lg" color="white" lineClamp={1}>
                                        {movie.title}
                                    </Text>
                                    <Text size="sm" color="gray" lineClamp={2} mt={5} style={{ opacity: 0.9 }}>
                                        {movie.description || "Experience the thrill of GSN Cinema."}
                                    </Text>
                                </Box>
                                <Button
                                    mt="md"
                                    variant="white"
                                    color="dark"
                                    radius="xl"
                                    fullWidth
                                    leftSection={<IconPlayerPlayFilled size={14} />}
                                >
                                    Book Now
                                </Button>
                            </Box>
                        </AspectRatio>
                    </Box>
                ))}
            </SimpleGrid>
        </Container>
    );
}

export default Movies;
